import { FormMarkup, useConfigurableAction,executeFunction } from "@shesha-io/reactjs";
import { CONFIGURABLE_ACTIONS_NAME, CONFIGURABLE_ACTIONS_OWNER } from "./model";

import settingsJson from './dynamic-action-settings.json';
import { HubConnection } from "@microsoft/signalr";

export interface IDynamicMessage {
    methodName: string;
    eventName: string;
    body: any;
}

const settingsMarkup = settingsJson as FormMarkup;



export const useSignalRinvokeAction = (connection: HubConnection) => {

    useConfigurableAction<IDynamicMessage>({
        owner: CONFIGURABLE_ACTIONS_OWNER,
        ownerUid: CONFIGURABLE_ACTIONS_OWNER,
        name: CONFIGURABLE_ACTIONS_NAME,
        argumentsFormMarkup: settingsMarkup,
        hasArguments: true,
        executer: (actionArgs, context) => {
            const { methodName, eventName, body } = actionArgs;
            // IActionExecutionContext declares named members and no index signature, so it is
            // not assignable to the { [key: string]: unknown } this expects. Spreading keeps the
            // same values without asserting.
            const result = executeFunction(body, { ...context });
            
            connection?.invoke(methodName, eventName, result);
           
            return Promise.resolve();
        }
    }, [connection]);
};